import { render } from "./MinisterForm.vue?vue&type=template&id=60334125&scoped=true&ts=true"
import script from "./MinisterForm.ts?vue&type=script&lang=ts"
export * from "./MinisterForm.ts?vue&type=script&lang=ts"

import "./MinisterForm.scss?vue&type=style&index=0&id=60334125&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60334125"]])

export default __exports__